import { reactive, watch } from 'vue';

const KEY = 'pds.display';

const defaults = {
  customerNote: true,
  expanded: false,
  itemCount: false,
  amount: false,
  compact: false,
};

export type DisplayPrefs = typeof defaults;

const read = (): DisplayPrefs => {
  try {
    return { ...defaults, ...JSON.parse(localStorage.getItem(KEY) ?? '{}') };
  } catch {
    return { ...defaults };
  }
};

// Propre à l'opérateur de la tablette : conservé sur l'appareil, jamais envoyé au serveur.
const prefs = reactive<DisplayPrefs>(read());

watch(prefs, (value) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // Stockage refusé : le réglage vaut pour la session seulement.
  }
});

export const useDisplayPrefs = () => prefs;
